import { useMutation } from '@apollo/client';
import { createError } from '@common/neo.tax';

import {
  CreateMergeDevAccessTokenForAccountingMutation,
  CreateMergeDevAccessTokenForAccountingMutationVariables,
  CREATE_MERGE_DEV_ACCESS_TOKEN_FOR_ACCOUNTING,
} from '@neo.tax/shared/graphql';

import { useCurrentUser } from '../useCurrentUser';
import { UseMergeDevAccountingParams } from './types';
import { useMergeDev } from './useMergeDev';

export const useMergeDevAccounting = ({
  companyId,
  isParentReady,
  onError,
  onSuccess,
  provider,
}: UseMergeDevAccountingParams): { onOpen: () => void } => {
  const { user } = useCurrentUser();
  if (!user) {
    throw createError('MissingCurrentUserError', 'Loader guard should have prevented rendering without current user');
  }

  const [createMergeDevAccessTokenForAccounting, { error }] = useMutation<
    CreateMergeDevAccessTokenForAccountingMutation,
    CreateMergeDevAccessTokenForAccountingMutationVariables
  >(CREATE_MERGE_DEV_ACCESS_TOKEN_FOR_ACCOUNTING);

  return useMergeDev(
    { companyId, isParentReady, onError, onSuccess, provider },
    async (publicToken: string) => {
      await createMergeDevAccessTokenForAccounting({
        variables: {
          userId: user.id,
          input: { companyId, mergeDevPublicToken: publicToken, accountingProvider: provider },
        },
      });
    },
    error,
    user.id,
  );
};
